export const YES_NO = 'yes_no';
export const SCALE_SATISFACTION = 'scale_satisfaction';
